export default "__VITE_ASSET__Dpn9DYYg__"